import { cn } from '@repo/ui';
import type { JSX, ReactNode } from 'react';

interface IPageFooterProps {
  children: ReactNode;
  className?: string;
}

export function PageFooter({ children, className }: IPageFooterProps): JSX.Element {
  return (
    <>
      <div aria-hidden className="h-14" />
      <div
        className={cn(
          'fixed inset-x-0 bottom-0 z-10 flex items-center justify-between bg-background/80 px-4 py-3 backdrop-blur-sm md:left-[var(--sidebar-width)] md:px-6',
          className,
        )}
      >
        {children}
      </div>
    </>
  );
}
